<template lang="pug">
  .b2b-table-auditorias
    //- Filtros Tabla Auditorias
    b2b-filters-auditorias(:filter-options='options' @updateAuditories="refreshAuditories")

    ods-table(
      :data='audits.tableData',
      :default-sort="{prop: 'inputDateTime', order: 'descending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='senderName',
        :label='$t("auditory.auditory_entity_table.sender")',
        :show-overflow-tooltip='true',
        v-if='isShowEmisorAuditorias',
        sortable='')
      ods-table-column(
        prop='receiverName',
        :label='$t("auditory.auditory_entity_table.receiver")',
        :show-overflow-tooltip='true',
        v-if='isShowReceptorAuditorias',
        sortable='')
      ods-table-column(
        prop='inputDateTime',
        :label='$t("auditory.auditory_entity_table.date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowFechaAuditorias',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='filename',
        :label='$t("auditory.auditory_entity_table.filename")',
        :show-overflow-tooltip='true',
        v-if='isShowNombreAuditorias',
        sortable='')
      ods-table-column(
        prop='documentNumber',
        :label='$t("auditory.auditory_entity_table.document_number")',
        :show-overflow-tooltip='true',
        v-if='isShowNumDocumentoAuditorias',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("auditory.auditory_entity_table.status")',
        :show-overflow-tooltip='true',
        v-if='isShowEstadoAuditorias',
        :formatter='formatterAuditoryStatus',
        sortable='')
      //- Ocultas por defecto
      ods-table-column(
        prop='project',
        :label='$t("auditory.auditory_entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowServicioAuditorias && !(this.activeUser.data.projects && this.activeUser.data.projects.length === 1)',
        sortable='')
      ods-table-column(
        prop='protocolName',
        :label='$t("auditory.auditory_entity_table.communication_protocol")',
        :show-overflow-tooltip='true',
        v-if='isShowComunicacionAuditorias',
        :formatter='formatterAuditoryProtocol',
        sortable='')
      ods-table-column(
        prop='moduleName',
        :label='$t("auditory.auditory_entity_table.audit_document_module")',
        :show-overflow-tooltip='true',
        v-if='isShowModuleAuditorias',
        :formatter='formatterAuditoryModule',
        sortable='')
      ods-table-column(
        prop='batch',
        :label='$t("auditory.auditory_entity_table.batch")',
        :show-overflow-tooltip='true',
        v-if='isShowLoteAuditorias',
        sortable=''
        :formatter='formatterBatch')
      ods-table-column(
        prop='processingTime',
        :label='$t("auditory.auditory_entity_table.processingTime")',
        :show-overflow-tooltip='true',
        v-if='isShowProcessingTimeAuditorias && canAdminIndra',
        sortable='')
      ods-table-column(
        label,
        align='right',
        :render-header='renderHeaderActions',
        width='120')
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('auditory.son') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              v-if='scope.row.childCount',
              @click='showChild(scope.row)')
              ods-icon(name='share', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('auditory.parent') }}
            ods-button(
              style=' padding-left: 8px; padding-right: 0px;'
              type='neutral',
              v-if='scope.row.idDocument',
              @click='showParent(scope.row)')
              ods-icon(name='broadcast', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 8px; padding-right: 0px; margin-right: 1rem;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')

    //- Paginación Tabla
    ods-row.b2b-table-auditorias__pagination(v-if='audits.totalAudits > 0')
      ods-col.b2b-table-auditorias__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadAllCsv')
            | CSV
      ods-col.b2b-table-auditorias__pagination--right(:span='20')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='audits.totalAudits')

    //- Auditorias Seleccionadas
    transition(
      name='slide',
      mode='out-in')
        b2b-table-select-rows(
          v-if='multipleSelection.length',
          :total-select='multipleSelection.length')
          div(slot='actions')
            ods-tooltip(:content='$t("auditory.buttons.btn_request_tooltip")', placement='bottom')
              ods-button(
                icon='ods-icon-download',
                size='small',
                circle,
                @click.native='handlePeticion')
                | {{ $t('auditory.buttons.btn_request') }}
            ods-tooltip(:content='$t("auditory.buttons.btn_response_tooltip")', placement='bottom')
              ods-button(
                icon='ods-icon-download',
                size='small',
                circle,
                @click.native='handleRespuesta')
                | {{ $t('auditory.buttons.btn_response') }}
            ods-tooltip(:content='$t("auditory.buttons.btn_incoming_file_tooltip")', placement='bottom')
              ods-button(
                icon='ods-icon-download',
                size='small',
                circle,
                @click.native='handleFicheroEntrada')
                | {{ $t('auditory.buttons.btn_incoming_file') }}
            ods-tooltip(:content='$t("auditory_detail.buttons.integrated_file_tooltip")', placement='bottom')
              ods-button(
                icon='ods-icon-download',
                size='small',
                circle,
                @click.native='handleFicheroIntegrado')
                | {{ $t('auditory_detail.buttons.integrated_file') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersAuditorias from '@/views/auditorias/documentos/B2bFiltersAuditoriaDocumentos'
import B2bTableMenuAuditorias from './B2bTableMenuAuditoriaDocumentos'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-auditorias'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-auditorias',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      downloadSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'audits',
      'queryAudits',
      'isShowEmisorAuditorias',
      'isShowReceptorAuditorias',
      'isShowFechaAuditorias',
      'isShowNombreAuditorias',
      'isShowNumDocumentoAuditorias',
      'isShowTipoDocumentoAuditorias',
      'isShowEstadoAuditorias',
      'isShowServicioAuditorias',
      'isShowComunicacionAuditorias',
      'isShowModuleAuditorias',
      'isShowLoteAuditorias',
      'isShowProcessingTimeAuditorias',
      'listSelectedFiltersAudits',
      'getActiveLang',
      'canAdminIndra',
      'activeUser'
    ])
  },

  components: {
    B2bFiltersAuditorias,
    B2bTableMenuAuditorias,
    B2bTableSelectRows
  },

  methods: {
    refreshAuditories () {
      this.loading = true
      this.cleanData()
      this.$forceUpdate()
      setTimeout(() => this.loading = false, 2000) // eslint-disable-line
    },
    ...mapActions([
      'getAudits',
      'queryAuditsState',
      'handleDownloadAllCsvAudits',
      'handleDownloadMultiAudits',
      'listSelectedFiltersAuditsState'
    ]),

    // Formatear estado de la auditoria
    formatterAuditoryStatus (row, column) {
      if (row[column.property]) return this.$t('auditory_status.' + row[column.property])
      else return ''
    },

    // Formatear protocolo de comunicacion de la auditoria
    formatterAuditoryProtocol (row, column) {
      if (row[column.property]) {
        let code = row[column.property]
        if (code.includes(' ')) {
          code = code.replace(' ', '_')
        } else if (code.includes('-')) {
          code = code.replace('-', '_')
        }
        return this.$t('auditory_communication_protocol.' + code)
      } else return ''
    },

    // Formatear modulo de la auditoria
    formatterAuditoryModule (row, column) {
      if (row[column.property]) {
        let code = row[column.property]
        if (code.includes(' ')) {
          code = code.replace(' ', '_')
        } else if (code.includes('-')) {
          code = code.replace('-', '_')
        }
        return this.$t('auditory_module.' + code)
      } else return ''
    },

    /* Formatear columna: Batch */
    formatterBatch (row) {
      if (row.batch || row.batch == null) {
        return this.$t('msg_generics.question.yes')
      } else {
        return this.$t('msg_generics.question.no')
      }
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (!prop) {
        prop = 'inputDateTime'
      } else {
        switch (prop) {
          case 'senderName':
            prop = 'partyByIdSender.tradeName'
            break
          case 'receiverName':
            prop = 'partyByIdReceiver.tradeName'
            break
          case 'status':
            prop = 'auditStatus.code'
            break
          case 'protocolName':
            prop = 'communicationsProtocol.name'
            break
          case 'moduleCode':
            prop = 'auditDocumentModule.code'
            break
        }
      }

      stringSort = prop + ',' + order
      this.queryAudits.sort = stringSort
      try {
        await this.queryAuditsState(this.queryAudits)
        dataQuery.query = this.queryAudits
        const response = await this.getAudits(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Descargar Todos los Csv */
    async handleDownloadAllCsv () {
      if (this.audits.totalAudits > 120000) {
        this.$notify({
          title: this.$t('auditory.auditory_entity_table.csv_title'),
          message: this.$t('auditory.auditory_entity_table.csv_message', { argumento: '120.000' }),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })
        const params = this.queryAudits
        try {
          params.activeLang = this.getActiveLang
          const filename = await this.handleDownloadAllCsvAudits(params)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleDownloadAllCsv CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    async cleanToShowData (audit, getParent) {
      try {
        const dataQuery = {
          query: {}
        }
        const myQueryAudits = {}
        await this.queryAuditsState(myQueryAudits)
        myQueryAudits.reset = true
        this.clearSelectedFilters = this.listSelectedFiltersAudits.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })
        console.log('CLEAR FILTERS: ', this.clearSelectedFilters)

        await this.listSelectedFiltersAuditsState(this.clearSelectedFilters)
        if (this.dateTimePickerValue && this.dateTimePickerValue[0]) {
          myQueryAudits.dateTimeFrom = this.dateTimePickerValue[0]
        }
        if (this.dateTimePickerValue && this.dateTimePickerValue[1]) {
          myQueryAudits.dateTimeTo = this.dateTimePickerValue[1]
        }
        if (getParent) {
          myQueryAudits.idParent = audit.idDocument
        } else {
          myQueryAudits.idParent = audit.id
          myQueryAudits.getChilds = true
        }

        await this.queryAuditsState(myQueryAudits)

        dataQuery.query = myQueryAudits
        await this.getAudits(dataQuery)

        this.selectedFilters = []
        await this.listSelectedFiltersAuditsState(this.selectedFilters)
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)

        myQueryAudits.idParent = null
        myQueryAudits.getChilds = null

        await this.queryAuditsState(myQueryAudits)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async showChild (audit) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        this.cleanToShowData(audit, false)
      } finally {
        load.close()
      }
    },

    async showParent (audit) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        this.cleanToShowData(audit, true)
      } finally {
        load.close()
      }
    },

    /* Ir al detalle */
    handleGoDetail () {
      if (this.currentRow.documentNumber) {
        sessionStorage.setItem('documentNumber', this.currentRow.documentNumber)
      } else if (this.currentRow.filename) {
        sessionStorage.setItem('documentNumber', this.currentRow.filename)
      } else if (this.currentRow.inputDateTime) {
        const date = moment(this.currentRow.inputDateTime)
        sessionStorage.setItem('documentNumber', date.format(this.$t('date_format_long')))
      }
      router.push({
        name: 'auditoria-documento-detail',
        params: {
          idAuditDocument: this.currentRow.id,
          documentNumber: this.currentRow.documentNumber
        }
      })
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuAuditorias />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryAudits.size = val
        await this.queryAuditsState(this.queryAudits)
        dataQuery.query = this.queryAudits
        const response = await this.getAudits(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryAudits.page = val - 1
        await this.queryAuditsState(this.queryAudits)
        dataQuery.query = this.queryAudits
        const response = await this.getAudits(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Seleccionadas
    /* Botón Peticiones REQUEST */
    async handlePeticion () {
      this.downloadSelectionIds = []
      let msgKo = this.$t('auditory.download_multiple.multiple_ko')
      let flag = true

      this.multipleSelection.forEach(element => {
        console.log(element)
        if (element.pathRequest == null) {
          msgKo += '\n' + element.filename
        } else {
          this.downloadSelectionIds.push(element.id)
          flag = false
        }
      })

      if (flag) {
        // Validacion erronea
        try {
          this.$confirm(msgKo, {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'icon-warning'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        }
      } else {
        // Validacion correcta
        const params = {
          auditoryIds: this.downloadSelectionIds,
          pathType: 'REQUEST'
        }
        try {
          await this.handleDownloadMultiAudits(params)
          this.$notify({
            title: this.$t('msg_generics.download_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handlePeticion() ->', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },

    /* Botón Respuestas RESPONSE */
    async handleRespuesta () {
      this.downloadSelectionIds = []
      let msgKo = this.$t('auditory.download_multiple.multiple_ko')
      let flag = true

      this.multipleSelection.forEach(element => {
        if (element.pathResponse === null) {
          msgKo += '\n' + element.filename
        } else {
          this.downloadSelectionIds.push(element.id)
          flag = false
        }
      })

      if (flag) {
        // Validacion erronea
        try {
          this.$confirm(msgKo, {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'icon-warning'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        }
      } else {
        // Validacion correcta
        const params = {
          auditoryIds: this.downloadSelectionIds,
          pathType: 'RESPONSE'
        }
        try {
          await this.handleDownloadMultiAudits(params)
          this.$notify({
            title: this.$t('msg_generics.download_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleRespuesta() ->', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },

    /* Botón Fichero entrada(incoming) */
    async handleFicheroEntrada () {
      this.downloadSelectionIds = []
      let msgKo = this.$t('auditory.download_multiple.multiple_ko')
      let flag = true

      this.multipleSelection.forEach(element => {
        if (element.incomingFile === null) {
          msgKo += '\n' + element.filename
        } else {
          this.downloadSelectionIds.push(element.id)
          flag = false
        }
      })

      if (flag) {
        // Validacion erronea
        try {
          this.$confirm(msgKo, {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'icon-warning'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        }
      } else {
        // Validacion correcta
        const params = {
          auditoryIds: this.downloadSelectionIds,
          pathType: 'INCOMING'
        }
        try {
          await this.handleDownloadMultiAudits(params)
          this.$notify({
            title: this.$t('msg_generics.download_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleFicheroEntrada() ->', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },

    /* Botón Fichero integrados */
    async handleFicheroIntegrado () {
      this.downloadSelectionIds = []
      let msgKo = this.$t('auditory.download_multiple.multiple_ko')
      let flag = true

      this.multipleSelection.forEach(element => {
        if (element.pathFile == null) {
          msgKo += '\n' + element.filename
        } else {
          this.downloadSelectionIds.push(element.id)
          flag = false
        }
      })

      if (flag) {
        // Validacion erronea
        try {
          this.$confirm(msgKo, {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'icon-warning'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        }
      } else {
        // Validacion correcta
        const params = {
          auditoryIds: this.downloadSelectionIds,
          pathType: 'INTEGRATED'
        }
        try {
          await this.handleDownloadMultiAudits(params)
          this.$notify({
            title: this.$t('msg_generics.download_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleFicheroIntegrado() ->', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },

    /* Botón CSV */
    handleExportCsvSelect () {
      console.log('handleExportCsv() ->', this.multipleSelectionIds)
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.options = filters.filters
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-auditorias {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}

</style>
